import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';


import { sharingValues } from '../../../../Shared/utils';

export default function PrintReports({ reports }) {
  const { t } = useTranslation();


  useEffect(() => { // Handle print
    const beforePrint = () => {
      // Force landscape printing so everything fits
      const css = '@media print { @page { size: landscape } }';
      const style = document.createElement('style');

      style.media = 'print';
      style.id = 'print-landscape';
      style.appendChild(document.createTextNode(css));

      document.head.appendChild(style);
      document.getElementById('print').style.display = 'block';
    };

    const afterPrint = () => {
      document.getElementById('print-landscape').remove();
      document.getElementById('print').style.display = 'none';
    };

    window.addEventListener('beforeprint', beforePrint);
    window.addEventListener('afterprint', afterPrint);

    return () => {
      window.removeEventListener('beforeprint', beforePrint);
      window.removeEventListener('afterprint', afterPrint);
    };
  }, []);


  return (
    <div id="print">
      <table id="print__header">
        <thead>
          <tr>
            <th id="print__logo">
              <img src="/assets/images/logo.png" alt="Logo" />
              <p style={{ display: 'none' /* used as brand name in excel file */ }}>SoftThinks</p>
            </th>
            <th style={{ fontSize: '24px', fontWeight: '600' }}>{t('global.dashboard')}</th>
          </tr>
          {/* Spacing */}<tr /><tr />
        </thead>

        <tbody style={{ fontWeight: '600' }}>
          <tr>
            <td>{t('admin.locations.print.header', { s: reports.length > 1 ? 's' : '' })}</td>
            <td>{reports.length}</td>
          </tr>
          {/* Spacing */}<tr /><tr /><tr />
        </tbody>
      </table>

      <table id="print__content">
        <thead>
          <tr>
            <th style={{ textAlign: 'center', width: '5%' }}>{t('admin.reports.columns.active')}</th>
            <th className="separation" />

            <th style={{ textAlign: 'left', width: '15%' }}>{t('admin.reports.columns.name')}</th>
            <th style={{ textAlign: 'right', width: '20%' }}>{t('admin.reports.columns.template')}</th>
            <th style={{ textAlign: 'left', width: '23%' }}>{t('admin.reports.columns.format')}</th>
            <th style={{ textAlign: 'left', width: '4%' }}>{t('admin.reports.columns.language')}</th>
            <th style={{ textAlign: 'left', width: '25%' }}>{t('admin.reports.columns.pageSize')}</th>
            <th style={{ textAlign: 'left', width: '25%' }}>{t('admin.reports.columns.sharingOptions')}</th>
            <th style={{ textAlign: 'left', width: '25%' }}>{t('admin.reports.columns.dateFormat')}</th>
          </tr>
        </thead>

        <tbody>
          {reports.map(rep => {

            let languageText = "";
            switch (rep.language) {
              default:
              case 'en':
                languageText = t('admin.reports.language.english')
                break;

              case 'fr':
                languageText = t('admin.reports.language.french')
                break;

              case 'es':
                languageText = t('admin.reports.language.spanish')
                break;

              case 'nl':
                languageText = t('admin.reports.language.dutch')
                break;
            }

            let sharedWithText = '';
            switch (rep.sharingOptions) {
              case 0:
                sharedWithText = t('scenarios.no_one');
                break;

              case 1:
                sharedWithText = t('scenarios.everyone');
                break;

              case 2:
                sharedWithText = t('scenarios.allStAdmins');
                break;

              case 3:
                sharedWithText = t('scenarios.allGroupAdmins');
                break;

              case 4:
                sharedWithText = t('scenarios.allGroupUsers');
                break;

              default:
                sharedWithText = "?";

            }
            return (
              <tr style={{ margin: '10px 0' }} key={rep.id}>
                <td style={{ textAlign: 'center' }}>{t('global.' + (rep.enabled ? 'yes' : 'no'))}</td>
                <td className="separation" />

                <td style={{ textAlign: 'left' }}>{rep.name}</td>
                <td style={{ textAlign: 'right' }}>{rep.templateTxt}</td>

                <td style={{ textAlign: 'left' }}>{rep.format.toUpperCase()}</td>
                <td style={{ textAlign: 'left' }}>{languageText}</td>

                <td style={{ textAlign: 'left' }}>{rep.pageSize.toUpperCase()}</td>
                <td style={{ textAlign: 'left' }}>{sharedWithText}</td>
                <td style={{ textAlign: 'left' }}>{rep.dateFormat}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  );
}